import { render, staticRenderFns } from "./operation-board-handover-tool.vue?vue&type=template&id=58b0c829&scoped=true&"
import script from "./operation-board-handover-tool.vue?vue&type=script&lang=js&"
export * from "./operation-board-handover-tool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b0c829",
  null
  
)

export default component.exports